export const SIDEBAR_WIDTH = '250';
export const BODY_COLOR = '#f9f9f9';
export const BORDER_COLOR = '#e1e1e1';

export const DATA_TABLE_STORAGE_KEYS = {
  activityLogs: 'activity-log-overview',
  plannedActivities: 'planned-activities-overview',
  clientPlannedActivities: 'client-planned-activities-overview',
  agents: 'agents-overview',
  clients: 'clients-overview',
  clientRetentionOverview: 'clients-retention-overview',
  clientOpportunitiesOverview: 'client-opportunities-overview',
  contactRetentionOverview: 'contact-retention-overview',
  contactOpportunitiesOverview: 'contact-opportunities-overview',
  contacts: 'contacts-overview',
  opportunities: 'opportunities-overview',
};

export const STORAGE_KEYS = {
  opportunitiesOverviewAgentFilter: 'opportunities-overview-agent-filter',
};
